import { APPROVAL_BLOCK_DATE, APPROVAL_BLOCK_DATE_SUCCESS, APPROVAL_BLOCK_DATE_ERROR, APPROVAL_BLOCK_DATE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApprovalBlockDate = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_BLOCK_DATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_BLOCK_DATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_BLOCK_DATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVAL_BLOCK_DATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApprovalBlockDate;
